import React, { ReactElement } from 'react'

type BasketFlashProps = {
  message: string;
}

const BasketFlash = ({
  message
}: BasketFlashProps): ReactElement => (
  <div className="basket-warning">{message}</div>
)

export default BasketFlash
